import { useEffect, useRef } from "react";
import { setHasExpired } from "store/features/compress/actions";
import { CompressImage } from "store/features/compress/types";
import { useAppDispatch } from "store/store";

const EXPIRY_TIME = 1000 * 60 * 60 * 4; // 4 hours
const CHECK_INTERVAL = 1000 * 60 * 10; // 10 minutes

export const useCheckExpiry = (image: CompressImage | null) => {
    const checkExpiryIntervalRef = useRef<NodeJS.Timer | null>(null);
    const dispatch = useAppDispatch();

    const checkExpiry = (image: CompressImage) => {
        if (checkExpiryIntervalRef.current) {
            clearInterval(checkExpiryIntervalRef.current);
            checkExpiryIntervalRef.current = null;
        }

        const imageId = image.id;

        checkExpiryIntervalRef.current = setInterval(async () => {
            if (!image.importTask?.endedAt) return;
            const passedSeconds = new Date().getTime() - new Date(image.importTask.createdAt).getTime();

            if (passedSeconds > EXPIRY_TIME) {
                dispatch(setHasExpired({ imageId, value: true }));
            }
        }, CHECK_INTERVAL);
    };

    useEffect(() => {
        if (!image) return;
        checkExpiry(image);
    }, [image?.id]);

    useEffect(() => {
        return () => {
            checkExpiryIntervalRef.current && clearInterval(checkExpiryIntervalRef.current);
        };
    }, []);
};
